import React, {useState} from "react";
import {IconButton, Tooltip} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {SquareLock01Icon, SquareUnlock01Icon} from "@hugeicons/core-free-icons";
import {useFlowProtection} from "../hooks/useFlowProtection";
import {currentProtectionProjectId} from "../utils/flowProtectionStorage";
import {FlowProtectionAuthModal} from "./modals/FlowProtectionAuthModal";

/**
 * Icon button that opens a modal to enter a registry project's protection password.
 * Once unlocked, protected user messages of the project are shown unmasked
 * for a limited time (see useFlowProtection). Drop this next to the debug
 * toggle in any conversation toolbar. projectId defaults to the open registry project;
 * without one (old flow projects) nothing is rendered.
 */
export const FlowProtectionButton = ({projectId = currentProtectionProjectId(), iconSize = 16}) => {
  const [open, setOpen] = useState(false);
  const {isUnlocked, unlock} = useFlowProtection(projectId);

  if (!projectId) return null;

  return (
    <>
      <Tooltip title={isUnlocked ? "Protected messages unlocked" : "Unlock protected messages"}>
        <IconButton
          onClick={() => setOpen(true)}
          sx={{
            width: 34, height: 34, borderRadius: "50% !important", border: "1px solid #ECECF3", bgcolor: "#fff",
            color: isUnlocked ? "#1E7F52" : "#4A4A63",
            "&:hover": {bgcolor: isUnlocked ? "#C9EBD8" : "#F4F4FA"},
            ...(isUnlocked ? {bgcolor: "#D9F2E4"} : {}),
          }}
        >
          <HugeiconsIcon icon={isUnlocked ? SquareUnlock01Icon : SquareLock01Icon} size={iconSize}/>
        </IconButton>
      </Tooltip>
      <FlowProtectionAuthModal
        open={open}
        projectId={projectId}
        onClose={() => setOpen(false)}
        onSuccess={(token, expiresInSeconds) => unlock(token, expiresInSeconds)}
      />
    </>
  );
};
